export class SendPaymentReceiptRequestDto {  
  AccountId: number = 0;  
  EmailBody='';    
  Subject='';  
  InvoiceIds!: number[];          
  EmailRecipients='';     
  LoggedInUserEmail='';   


}


